import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { CardComponent } from '@microsec/components';
import { DOMAIN } from '@microsec/constants';

const OPTION_VALUES = {
  CHANGE_PASSWORD: 'change_password',
  TWO_FACTOR_AUTHENTICATION: 'two_factor_authentication',
};

@Component({
  selector: 'app-account-security',
  templateUrl: './account-security.component.html',
  styleUrls: ['./account-security.component.scss'],
  imports: [CommonModule, DividerModule, ButtonModule, CardComponent],
})
export class AccountSecurityComponent {
  options = signal([
    {
      label: 'Change Password',
      desc: 'Change your password or recover your current one.',
      buttonText: 'Change Password',
      value: OPTION_VALUES.CHANGE_PASSWORD,
    },
    {
      label: 'Two-Factor Authentication',
      desc: "Increase your account's security by enabling two-factor authentication (2FA).",
      buttonText: 'Manage in Account Console',
      value: OPTION_VALUES.TWO_FACTOR_AUTHENTICATION,
    },
  ]);

  selection = signal(this.options()[0]);

  OPTION_VALUES = OPTION_VALUES;

  openLink() {
    window.open(`https://${localStorage.getItem(DOMAIN)}/auth/realms/microsec/account/account-security/signing-in`, '_blank');
  }
}
